// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPicLeftOutlinedSvg from "@fishx/icons-svg/es/asn/PPicLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var PPicLeftOutlined = function PPicLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPicLeftOutlinedSvg
  }));
};

PPicLeftOutlined.displayName = 'PPicLeftOutlined';
export default React.forwardRef(PPicLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPicLeftOutlined.js
// module id = 3536
// module chunks = 0